import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Button, hiddenOffScreen, Input, Theme } from 'localmed-core';
import * as React from 'react';
import { Search } from 'react-feather';
import { WidthProps } from 'styled-system';
import InputGroup from './InputGroup';

type InputProps = React.ComponentProps<typeof Input>;
type ButtonProps = React.ComponentProps<typeof Button>;

type Props = InputProps &
  WidthProps & {
    id?: string;
    name: string;
    type?: string;
    value?: string;
    onButtonClick?: ButtonProps['onClick'];
    onChange?: InputProps['onChange'];
    onKeyDown?: InputProps['onKeyDown'];
    placeholder?: string;
    label?: string;
    buttonDisabled?: boolean;
  };

const Label = styled('label')<React.ComponentProps<'label'>, Theme>(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.xxs};
    color: ${theme.colors.muted};
  `
);

export default function SearchInputGroup({
  id,
  name,
  type = 'text',
  value,
  onButtonClick,
  onChange,
  onKeyDown,
  placeholder = 'Search…',
  label,
  width: widthProp,
  buttonDisabled,
  ...props
}: Props) {
  return (
    <React.Fragment>
      {label && <Label htmlFor={id}>{label}</Label>}
      <InputGroup width={widthProp}>
        <Input
          {...props}
          id={id}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
        />
        <Button
          type="submit"
          tier="emphasis"
          onClick={onButtonClick}
          disabled={buttonDisabled ?? props.disabled}
        >
          <Search size="1.125em" />
          <div css={hiddenOffScreen}>Search</div>
        </Button>
      </InputGroup>
    </React.Fragment>
  );
}
